/* eslint-disable camelcase */
import { Audio, Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';

export default class WordSelector extends Phaser.GameObjects.Container {
  static get WORD_SELECTED() {return 'WORD_SELECTED';}

  constructor(scene, levelData) {
    super(scene);
    this.name = `word_bank_${levelData.levelImage}`;

    Images.addImage(0, 0, this.name, this).setOrigin(0,0);

    const wordsArray = levelData.words;
    const posArray = levelData.positioning;
    this.shapes = [];
    this.graphics = this.scene.add.graphics();
    this.selectedBankWord = null;

    let row = 0;
    let col = 0;

    for (let i = 0; i < wordsArray.length; i++) {

      const adjustX = posArray[0];
      const adjustY = posArray[1];

      const text = wordsArray[i];
      const textLabel = this.scene.add.text((col * 145) + 70 + adjustX, (row * 55) + 100 + adjustY, text, { fontFamily: 'carton_sixregular', color: '#fff', fontSize: '20pt', align: 'left' });
      this.add(textLabel);

      const areaColor = levelData.colors[0];
      const strikeColor = levelData.colors[1];

      const paddingX = 10;

      const fieldShape = this.scene.add.rectangle(textLabel.x - paddingX, textLabel.y, textLabel.width + 2 * paddingX, textLabel.height * 1.5, areaColor, 0).setOrigin(0);
      fieldShape.number = i;

      this.shapes.push(fieldShape);

      this.add(fieldShape);

      const xx = textLabel.x - paddingX - 0;
      const yPoint = textLabel.y + textLabel.height / 2 + paddingX / 2;
      const line = this.scene.add.rectangle(xx - 2, yPoint - 4, textLabel.width + 2 * paddingX, 4,strikeColor).setOrigin(0);
      line.setAlpha(0);
      this.add(line);
      fieldShape.line = line;
      fieldShape.text = text;

      fieldShape.roundedRect = this.scene.add.graphics();
      fieldShape.roundedRect.fillStyle(areaColor, .5);
      fieldShape.roundedRect.fillRoundedRect(textLabel.x - paddingX, textLabel.y - 3, textLabel.width + 2 * paddingX, textLabel.height * 1.5);
      fieldShape.roundedRect.setAlpha(0);
      fieldShape.roundedRect.restX = fieldShape.roundedRect.x;
      fieldShape.roundedRect.destX = fieldShape.roundedRect.x + 3;
      this.add(fieldShape.roundedRect);

      fieldShape.setInteractive({ useCursor: true });
      fieldShape.on('pointerdown', () => { this.handleClick(fieldShape);});

      this.bringToTop(textLabel);
      this.bringToTop(line);

      col++;
      if (col === 5) {
        col = 0;
        row++;
      }
    }
  };

  disableWord(index) {
    const shape = this.shapes[index];
    Tweens.addTween(shape.roundedRect, 100, { alpha: 0 });
    shape.alpha = 0;
    shape.line.alpha = 1;
    shape.disabled = true;
  }

  handleClick(fieldShape) {
    if (this.selectedBankWord !== fieldShape.roundedRect) {
      Audio.playOneShot('select_word', this.scene);

      fieldShape.roundedRect.setAlpha(1);

      if (this.selectedBankWord) {
        this.selectedBankWord.setAlpha(0);
        this.scene.tweens.killTweensOf(this.selectedBankWord);
      }

      this.selectedBankWord = fieldShape.roundedRect;

      this.emit(WordSelector.WORD_SELECTED, fieldShape);

      Tweens.addTween(this.selectedBankWord, 300, { x: { start: this.selectedBankWord.restX, to: this.selectedBankWord.destX }, yoyo: true, loop: 1 });
    }
  }
}